import { render, staticRenderFns } from "./ProfielWijzigen.vue?vue&type=template&id=f8588b88&scoped=true"
import script from "./ProfielWijzigen.vue?vue&type=script&lang=js"
export * from "./ProfielWijzigen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8588b88",
  null
  
)

export default component.exports